import React from 'react';
import { Button } from '../ui/Button';
import { ShieldCheck, Lock, Download } from 'lucide-react';
export function Pricing() {
  return <section id="pricing" className="py-24 bg-gradient-to-b from-white to-amber-50" data-id="element-176">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl" data-id="element-177">
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-amber-100" data-id="element-178">
          <div className="bg-stone-900 p-6 text-center" data-id="element-179">
            <h2 className="text-2xl md:text-3xl font-bold text-white font-serif" data-id="element-180">
              The Offer
            </h2>
          </div>

          <div className="p-6 sm:p-8 md:p-12" data-id="element-181">
            {/* Price Anchoring */}
            <div className="space-y-6 mb-10 text-stone-600 text-center" data-id="element-182">
              <p className="text-lg" data-id="element-183">
                If you went to a high-end wellness clinic in Florida or
                California, you'd pay{' '}
                <span className="font-bold text-stone-900 decoration-red-500 decoration-2 line-through" data-id="element-184">
                  $350+
                </span>{' '}
                for a metabolic consultation like this.
              </p>
              <p className="text-lg" data-id="element-185">
                You could spend{' '}
                <span className="font-bold text-stone-900 decoration-red-500 decoration-2 line-through" data-id="element-186">
                  $150
                </span>{' '}
                on high-end creams that only mask the problem.
              </p>
              <p className="text-lg font-medium text-amber-700" data-id="element-187">
                But because my mission is to help 10,000 women regain their
                confidence this year...
              </p>
            </div>

            {/* Price Box */}
            <div className="mb-8 p-6 bg-amber-50 rounded-2xl border border-amber-200 w-full max-w-lg mx-auto text-center" data-id="element-188">
              <p className="text-stone-500 mb-2 text-sm uppercase tracking-wide" data-id="element-189">
                You won't pay $350. You won't even pay $97.
              </p>
              <p className="text-stone-900 font-bold mb-4" data-id="element-190">
                Get the entire "Golden Root Ritual" Protocol today for a
                one-time payment of:
              </p>

              <div className="flex items-center justify-center gap-4 mb-2" data-id="element-191">
                <span className="text-4xl text-stone-400 line-through font-serif decoration-red-500 decoration-2" data-id="element-192">
                  $97
                </span>
                <span className="text-6xl md:text-7xl font-bold text-amber-600 font-serif" data-id="element-193">
                  $17{' '}
                  <span className="text-xl text-stone-500 font-sans font-normal" data-id="element-194">
                    USD
                  </span>
                </span>
              </div>
            </div>

            {/* Urgency */}
            <p className="text-center text-stone-600 italic mb-8 max-w-xl mx-auto" data-id="element-195">
              Every day you wait is another day of inflammation building up in
              your system. The longer cortisol stays elevated, the harder it
              becomes to reverse.{' '}
              <strong className="text-stone-900 not-italic" data-id="element-196">
                Start tomorrow morning—not next month.
              </strong>
            </p>

            {/* CTA */}
            <div className="flex flex-col items-center gap-4 px-0" data-id="element-197">
              <Button size="xl" className="w-full sm:w-auto text-base sm:text-xl px-6 sm:px-10 py-4 sm:py-5 shadow-amber-500/30 shadow-xl" showIcon={true} data-id="element-198">
                SEND ME THE GOLDEN ROOT RITUAL
              </Button>

              {/* Trust Badges */}
              <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6 mt-6 text-sm text-stone-500" data-id="element-199">
                <div className="flex items-center gap-2" data-id="element-200">
                  <Lock className="w-4 h-4 text-green-600" data-id="element-201" />
                  <span data-id="element-202">SSL Secure</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-203">
                  <ShieldCheck className="w-4 h-4 text-green-600" data-id="element-204" />
                  <span data-id="element-205">7-Day Guarantee</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-206">
                  <Download className="w-4 h-4 text-green-600" data-id="element-207" />
                  <span data-id="element-208">Instant Download</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}